import {
  CLEAR_FISCAL_INTEREST_BALANCE,
  CLEAR_FISCAL_INTEREST_BALANCE_OPTIONS,
  LOAD_FISCAL_INTEREST_BALANCE,
  SAVE_FISCAL_INTEREST_BALANCE_OPTIONS,
  CLEAR_ACCOUNTING_INTEREST_BALANCE,
  CLEAR_ACCOUNTING_INTEREST_BALANCE_OPTIONS,
  LOAD_ACCOUNTING_INTEREST_BALANCE,
  SAVE_ACCOUNTING_INTEREST_BALANCE_OPTIONS
} from '../actions/interestBalanceActions';

const initialState = {
  fiscal: {
    options: { limit: +process.env.REACT_APP_TABLE_SIZE, page: 0 },
    items: [],
    count: 0
  },
  accounting: {
    options: { limit: +process.env.REACT_APP_TABLE_SIZE, page: 0 },
    items: [],
    count: 0
  }
};

const interestBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FISCAL_INTEREST_BALANCE.success: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          items: action.items,
          count: action.count
        }
      };
    }
    case SAVE_FISCAL_INTEREST_BALANCE_OPTIONS: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          options: { ...state.fiscal.options, ...action.options }
        }
      };
    }
    case CLEAR_FISCAL_INTEREST_BALANCE_OPTIONS: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          options: initialState.fiscal.options
        }
      };
    }
    case CLEAR_FISCAL_INTEREST_BALANCE: {
      return {
        ...state,
        fiscal: initialState.fiscal
      };
    }
    case LOAD_ACCOUNTING_INTEREST_BALANCE.success: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          items: action.items,
          count: action.count
        }
      };
    }
    case SAVE_ACCOUNTING_INTEREST_BALANCE_OPTIONS: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          options: { ...state.accounting.options, ...action.options }
        }
      };
    }
    case CLEAR_ACCOUNTING_INTEREST_BALANCE_OPTIONS: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          options: initialState.accounting.options
        }
      };
    }
    case CLEAR_ACCOUNTING_INTEREST_BALANCE: {
      return {
        ...state,
        accounting: initialState.accounting
      };
    }
    default: {
      return state;
    }
  }
};

export default interestBalanceReducer;
